<template>
  <div class="rounded-lg border border-slate-200 bg-white p-6 shadow-sm">
    <h2 class="mb-4 text-xl font-semibold text-slate-900">
      Overview
    </h2>
    <p class="text-slate-700 leading-relaxed">
      {{ overview }}
    </p>
  </div>
</template>
<script setup lang="ts">
interface Props {
  overview: string
  companyName: string
}
defineProps<Props>()
</script>